import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Icon } from '@elparking/components'
import { PARKING_TYPE_AIRPORT, PARKING_TYPES } from 'commons/js/constants'

function ParkingIcon ({ isMarked, isActive, parkingType }) {
    const iconType = parkingType === PARKING_TYPE_AIRPORT ? 'plane-signal' : 'border-truck-fill'

    if (!isActive) {
        return <Icon type={iconType} color='red' size='xLarge'/>
    }

    if (isMarked) {
        return <Icon type={iconType} color='main' size='xLarge'/>
    }

    return <Icon type={iconType} color='white' size='xLarge'/>
}

ParkingIcon.propTypes = {
    isMarked: PropTypes.bool,
    isActive: PropTypes.bool,
    parkingType: PropTypes.string,
}

const IconWrapper = styled.div`
    display: inline-block;
    width: 22px;
    height: 22px;
    margin-right: 5px;
`

const PriceIcon = ({ isMarked, isActive, parkingType, isTruckParking }) => {
    if (parkingType !== PARKING_TYPE_AIRPORT && !isTruckParking) {
        return null
    }

    return (
        <IconWrapper>
            <ParkingIcon isMarked={isMarked} isActive={isActive} parkingType={parkingType} />
        </IconWrapper>
    )
}

PriceIcon.propTypes = {
    parkingType: PropTypes.oneOf(PARKING_TYPES).isRequired,
    isMarked: PropTypes.bool,
    isActive: PropTypes.bool,
    isTruckParking: PropTypes.bool,
}

export default PriceIcon
